/* BeanBurds Coffee template — shell behaviour only.
   Filtering/sort/grid are native Shopify (server-rendered) — no client facet engine,
   no demo data, no hash router. Handles: drawers + focus, iOS-safe scroll lock,
   real add-to-cart + header cart-bubble sync, intro read-more, GA4 events (§9). */
(function () {
  'use strict';
  if (window.__bbcInit) return; window.__bbcInit = true;
  var root = document.querySelector('[data-bbc-collection]');
  var COLLURL = root ? root.getAttribute('data-bbc-collection-url') : '';
  var COLL = root ? root.getAttribute('data-bbc-collection') : '';
  function ga(name, params) { try { if (window.gtag) window.gtag('event', name, params || {}); } catch (e) {} }

  /* ---- Shield product links from third-party click hijacking ----
     Restock Rocket decorates our card anchors (adds .restock-rocket-col) and its
     click handler, failing to parse this card markup, navigates to '/' instead of
     the product. Stopping propagation at window-capture keeps ALL later handlers
     (RR's included) off these clicks while the anchor's default navigation — the
     browser's own, unpreventable-by-propagation — proceeds to the product page.
     select_item tracking moves here because the bubble-phase copy no longer runs. */
  window.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('.bbc-root a[href*="/products/"]');
    if (!a) return;
    e.stopPropagation();
    var itm = a.closest('[data-bbc-item]');
    if (itm) ga('select_item', { item_id: itm.getAttribute('data-bbc-item'), item_name: itm.getAttribute('data-name') });
  }, true);
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---- iOS-safe scroll lock ---- */
  var lockY = 0;
  function lock() { lockY = window.scrollY || window.pageYOffset || 0; document.body.style.top = '-' + lockY + 'px'; document.body.classList.add('bbc-locked'); }
  function unlock() { document.body.classList.remove('bbc-locked'); document.body.style.top = ''; window.scrollTo(0, lockY); }

  /* ---- drawers (menu / filters / cart) + focus management ---- */
  var openEl = null, lastTrigger = null;
  function openDrawer(el, trigger) {
    if (!el) return;
    el.classList.add('open'); el.setAttribute('aria-hidden', 'false');
    lock(); openEl = el; lastTrigger = trigger || null;
    var f = el.querySelector('[data-bbc-close]') || el.querySelector('button, a, input');
    if (f) f.focus();
  }
  function closeDrawer() {
    if (!openEl) return;
    openEl.classList.remove('open'); openEl.setAttribute('aria-hidden', 'true');
    unlock(); if (lastTrigger && lastTrigger.focus) lastTrigger.focus(); openEl = null;
  }
  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('[data-bbc-close]');
    if (c) { e.preventDefault(); closeDrawer(); }
    var ov = e.target.closest && e.target.closest('[data-bbc-overlay]');
    if (ov && e.target === ov) closeDrawer();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openEl) closeDrawer(); });
  $$('[data-bbc-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer(document.getElementById(btn.getAttribute('data-bbc-open')), btn);
    });
  });

  /* ---- GA4: circle taps + xsell taps ---- */
  document.addEventListener('click', function (e) {
    var circ = e.target.closest && e.target.closest('[data-bbc-circle]');
    if (circ) ga('bb_circle_tap', { target_handle: circ.getAttribute('data-handle'), source_collection: COLL });
    var xs = e.target.closest && e.target.closest('[data-bbc-xsell]');
    if (xs) ga('bb_xsell_tap', { target: xs.getAttribute('data-target'), source_collection: COLL });
    var itm = e.target.closest && e.target.closest('[data-bbc-item]');
    if (itm && !e.target.closest('[data-bbc-add]')) ga('select_item', { item_id: itm.getAttribute('data-bbc-item'), item_name: itm.getAttribute('data-name') });
  });

  /* ---- intro read-more (content is fully in the DOM; this only toggles the clamp) ---- */
  var moreBtn = document.getElementById('bbc-introMore');
  if (moreBtn) moreBtn.addEventListener('click', function () {
    var intro = document.getElementById('bbc-intro');
    var expanded = intro.classList.toggle('bbc-expanded');
    moreBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    moreBtn.textContent = expanded ? 'Read less' : 'Read more';
    if (expanded) ga('bb_intro_expand', { collection: COLL });
  });

  /* ---- real add-to-cart + header cart-bubble sync (theme <cart-icon>) ---- */
  function updateCartBubble(n) {
    $$('.cart-bubble__text-count').forEach(function (el) { el.textContent = n < 100 ? String(n) : ''; el.classList.toggle('hidden', n === 0); });
    $$('.cart-bubble').forEach(function (el) { el.classList.toggle('visually-hidden', n === 0); });
    $$('cart-icon').forEach(function (el) { el.classList.toggle('header-actions__cart-icon--has-cart', n > 0); });
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }
  var _toastT;
  function bbToast(msg) {
    var host = document.querySelector('.bbc-root') || document.body;
    var t = document.getElementById('bbc-toast');
    if (!t) { t = document.createElement('div'); t.id = 'bbc-toast'; t.className = 'toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); host.appendChild(t); }
    t.textContent = msg;
    requestAnimationFrame(function () { t.classList.add('show'); });
    clearTimeout(_toastT); _toastT = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }
  var FREE_SHIP = 300; /* AED — matches trust chip + spec */
  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('[data-bbc-add]');
    if (!add || add.hasAttribute('disabled')) return;
    e.preventDefault();
    var vid = parseInt(add.getAttribute('data-bbc-add'), 10);
    var name = add.getAttribute('data-name') || 'Item';
    add.disabled = true;
    var payload = { id: vid, quantity: 1 };
    if (add.getAttribute('data-bbc-plan')) payload.selling_plan = parseInt(add.getAttribute('data-bbc-plan'), 10);
    if (add.hasAttribute('data-bbc-discovery')) {
      var dc = add.closest('.card--discovery');
      var pick = dc && dc.querySelector('.dchip.selected');
      if (pick) payload.properties = { 'Flavour notes': pick.getAttribute('data-bbc-dchip') };
    }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { if (!r.ok) throw new Error('add');
        /* add_to_cart GA4 event intentionally NOT fired here: the parent theme's cart
           tracking already emits gtag add_to_cart (with value) on /cart/add.js — firing
           ours too double-counts. Verified live 2026-07-18. */
        return fetch('/cart.js').then(function (x) { return x.json(); }); })
      .then(function (cart) {
        updateCartBubble(cart.item_count || 0);
        var left = FREE_SHIP - (cart.total_price || 0) / 100;
        var aed = function (n) { n = Math.round(n * 100) / 100; return 'AED ' + (n % 1 ? n.toFixed(2) : n); };
        bbToast(left > 0 ? name + ' added — ' + aed(left) + ' away from free delivery.' : name + ' added — free delivery unlocked.');
      })
      .catch(function () { window.location.href = add.getAttribute('data-url') || '/cart'; })
      .then(function () { add.disabled = false; });
  });

  /* ---- favourites (client-side, v3) ---- */
  var FKEY = 'bbc-favs';
  function favSet() { try { return new Set(JSON.parse(localStorage.getItem(FKEY) || '[]')); } catch (e) { return new Set(); } }
  function paintFavs() {
    var f = favSet();
    $$('[data-bbc-fav]').forEach(function (b) {
      var on = f.has(String(b.getAttribute('data-bbc-fav')));
      b.classList.toggle('active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var fav = e.target.closest && e.target.closest('[data-bbc-fav]');
    if (!fav) return;
    e.preventDefault();
    var id = String(fav.getAttribute('data-bbc-fav')), f = favSet(), on = !f.has(id);
    if (on) f.add(id); else f.delete(id);
    try { localStorage.setItem(FKEY, JSON.stringify(Array.from(f))); } catch (x) {}
    fav.classList.toggle('active', on);
    fav.setAttribute('aria-pressed', on ? 'true' : 'false');
    bbToast(on ? 'Saved to your favourites.' : 'Removed from favourites.');
    ga('bb_fav_toggle', { item_id: id, saved: on });
  });
  paintFavs();

  /* ---- trust chip detail on tap (v3) ---- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.trust-item');
    if (t && t.getAttribute('data-detail')) bbToast(t.getAttribute('data-detail'));
  });

  /* ---- load more (v3 PAGE growth, server-backed) ---- */
  (function () {
    var btn = document.getElementById('bbc-loadMore');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-bbc-next');
      if (!url) return;
      btn.disabled = true; btn.textContent = 'Loading\u2026';
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = document.getElementById('bbc-grid');
        var incoming = doc.getElementById('bbc-grid');
        if (grid && incoming) {
          $$('article.card', incoming).forEach(function (c) { grid.insertBefore(c, document.getElementById('bbc-loadWrap')); });
        }
        var nb = doc.getElementById('bbc-loadMore');
        var next = nb && nb.getAttribute('data-bbc-next');
        if (next) { btn.setAttribute('data-bbc-next', next); btn.disabled = false; btn.textContent = 'Load more'; }
        else { var w = document.getElementById('bbc-loadWrap'); if (w) w.remove(); }
        paintFavs();
        syncResultCount();
        ga('bb_load_more', { url: url });
      }).catch(function () { btn.disabled = false; btn.textContent = 'Load more'; });
    });
  })();

  /* ---- sort select submits its form (preserves active filters via hidden inputs) ---- */
  $$('[data-bbc-sort]').forEach(function (sel) { sel.addEventListener('change', function () { if (sel.form) sel.form.submit(); }); });

  /* ---- coffee finder quiz: v3 three-step flow -> combined native filter URL ---- */
  var quiz = document.getElementById('bbc-quiz');
  if (quiz) {
    var map = {}; try { map = JSON.parse(quiz.getAttribute('data-bbc-filtermap') || '{}'); } catch (e) { map = {}; }
    (function dec(o) { var ta = document.createElement('textarea'); Object.keys(o || {}).forEach(function (k) { var v = o[k]; if (v && typeof v === 'object') dec(v); else if (typeof v === 'string') { ta.innerHTML = v; o[k] = ta.value; } }); })(map);
    var QURL = quiz.getAttribute('data-bbc-collection-url') || COLLURL || '';
    var questions = [
      { title: 'How do you brew?', hint: 'Choose the option closest to your daily setup.', options: ['Filter', 'Espresso', 'Omni \u2014 a bit of both'] },
      { title: 'Which flavours pull you in?', hint: 'There is no wrong answer.', options: ['Fruity', 'Chocolate', 'Floral', 'Nutty'] },
      { title: 'How adventurous are you feeling?', hint: 'We tune the roast profile to this.', options: ['Comforting classics', 'Bright and expressive'] }
    ];
    var qi = 0, answers = [];
    function paintQuiz() {
      var x = questions[qi];
      var st = document.getElementById('bbc-quizStep'); if (st) st.textContent = 'Question ' + (qi + 1) + ' of ' + questions.length;
      var ti = document.getElementById('bbc-quizTitle'); if (ti) ti.textContent = x.title;
      var hi = document.getElementById('bbc-quizHint'); if (hi) hi.textContent = x.hint;
      var op = document.getElementById('bbc-quizOptions');
      if (op) op.innerHTML = x.options.map(function (o) {
        return '<button type="button" class="quiz-option' + (answers[qi] === o ? ' selected' : '') + '" data-bbc-answer="' + o.replace(/"/g, '&quot;') + '">' + o + '</button>';
      }).join('');
      var nx = document.getElementById('bbc-quizNext'); if (nx) nx.textContent = qi === questions.length - 1 ? 'Show my matches' : 'Continue';
    }
    function lookup(group, label) { return map[group] && map[group][label] ? map[group][label] : null; }
    function quizHref() {
      var pairs = [];
      var brew = answers[0] || '', flav = answers[1] || '', mood = answers[2] || '';
      var m;
      if (brew === 'Filter') { m = lookup('brew', 'Filter'); if (m) pairs.push(m); }
      else if (brew === 'Espresso') { m = lookup('brew', 'Espresso'); if (m) pairs.push(m); }
      else if (brew) { m = lookup('roast', 'Omni Roast'); if (m) pairs.push(m); }
      var flavMap = { 'Fruity': 'Fruity & Berries', 'Chocolate': 'Chocolate & Nutty', 'Floral': 'Floral & Tea', 'Nutty': 'Chocolate & Nutty' };
      if (flavMap[flav]) { m = lookup('flavour', flavMap[flav]); if (m) pairs.push(m); }
      if (mood === 'Comforting classics') { ['Medium', 'Medium Dark'].forEach(function (r) { var x = lookup('roast', r); if (x) pairs.push(x); }); }
      if (mood === 'Bright and expressive') { ['Light', 'Light Medium'].forEach(function (r) { var x = lookup('roast', r); if (x) pairs.push(x); }); }
      if (!pairs.length) return QURL;
      var sep = QURL.indexOf('?') > -1 ? '&' : '?';
      return QURL + sep + pairs.map(function (p) { return encodeURIComponent(p.param) + '=' + encodeURIComponent(p.value); }).join('&') + '#bbc-grid';
    }
    var opts = document.getElementById('bbc-quizOptions');
    if (opts) opts.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bbc-answer]'); if (!b) return;
      answers[qi] = b.getAttribute('data-bbc-answer');
      $$('.quiz-option', opts).forEach(function (o) { o.classList.toggle('selected', o === b); });
    });
    var nextBtn = document.getElementById('bbc-quizNext');
    if (nextBtn) nextBtn.addEventListener('click', function () {
      if (!answers[qi]) { bbToast('Pick an option to continue.'); return; }
      if (qi < questions.length - 1) { qi++; paintQuiz(); return; }
      ga('bb_quiz_complete', { brew: answers[0], flavour: answers[1], mood: answers[2] });
      var dest = quizHref();
      nextBtn.disabled = true; nextBtn.textContent = 'Finding your matches\u2026';
      fetch(dest).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['bbc-grid', 'bbc-pillsSlot', 'bbc-quicktabs', 'desktopFilters'].forEach(function (id) {
          var from = doc.getElementById(id), to = document.getElementById(id);
          if (from && to) to.innerHTML = from.innerHTML;
        });
        var fc = doc.getElementById('bbc-resultCount'), tc = document.getElementById('bbc-resultCount');
        if (fc && tc) { tc.textContent = fc.textContent; tc.setAttribute('data-total', fc.getAttribute('data-total') || ''); }
        var fd = doc.querySelector('#bbc-filterDrawer .drawer-body'), td = document.querySelector('#bbc-filterDrawer .drawer-body');
        if (fd && td) td.innerHTML = fd.innerHTML;
        try { history.pushState({}, '', dest); } catch (e) {}
        if (window.__bbcApplyView) window.__bbcApplyView();
        if (window.__bbcInitAutoload) window.__bbcInitAutoload();
        paintFavs();
        closeDrawer();
        var g = document.getElementById('bbc-grid');
        if (g) g.scrollIntoView({ behavior: 'smooth', block: 'start' });
        bbToast('Your matches are ready.');
      }).catch(function () { window.location.href = dest; })
        .then(function () { nextBtn.disabled = false; nextBtn.textContent = 'Show my matches'; });
    });
    $$('[data-bbc-open="bbc-quiz"]').forEach(function (b) {
      b.addEventListener('click', function () { qi = 0; answers = []; paintQuiz(); ga('bb_quiz_open', {}); });
    });
    paintQuiz();
  }

  /* ---- rail: show-more caps, roaster search, result-count sync (v3) ---- */
  $$('[data-bbc-more]').forEach(function (btn) {
    var label = btn.textContent;
    btn.addEventListener('click', function () {
      var group = btn.closest('.fgroup');
      var open = btn.getAttribute('data-open') === '1';
      $$('.opt', group).forEach(function (el) {
        if (el.getAttribute('data-bbc-capped') === '1' || el.classList.contains('capped-hide')) {
          if (!open) { el.setAttribute('data-bbc-capped', '1'); el.classList.remove('capped-hide'); }
          else { el.classList.add('capped-hide'); }
        }
      });
      btn.setAttribute('data-open', open ? '0' : '1');
      btn.textContent = open ? label : 'Show less';
    });
  });
  $$('[data-bbc-rsearch]').forEach(function (inp) {
    inp.addEventListener('input', function () {
      var q = inp.value.trim().toLowerCase();
      var group = inp.closest('.fgroup');
      $$('.opt.roaster', group).forEach(function (row) {
        var name = (row.textContent || '').toLowerCase();
        var capped = row.classList.contains('capped-hide');
        if (q) { row.style.display = name.indexOf(q) > -1 ? 'flex' : 'none'; }
        else { row.style.display = capped ? '' : 'flex'; }
      });
    });
  });
  function syncResultCount() {
    var el = document.getElementById('bbc-resultCount');
    if (!el) return;
    var total = parseInt(el.getAttribute('data-total'), 10) || 0;
    var shown = document.querySelectorAll('#bbc-grid article.card').length;
    el.textContent = 'Showing ' + shown + ' of ' + total + (total === 1 ? ' coffee' : ' coffees');
  }

  /* ---- near-instant nav: warm the cache for circles/chips/pills on intent ---- */
  (function () {
    var warmed = new Set();
    function warm(a) {
      var href = a && a.href;
      if (!href || warmed.has(href) || a.origin !== location.origin) return;
      warmed.add(href);
      var l = document.createElement('link'); l.rel = 'prefetch'; l.href = href; l.as = 'document';
      document.head.appendChild(l);
    }
    ['pointerenter', 'touchstart', 'focusin'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        var a = e.target.closest && e.target.closest('a.cat, a.qtab, a.pill, #bbc-loadMore');
        if (a && a.tagName === 'A') warm(a);
      }, { passive: true, capture: true });
    });
  })();

  /* ---- sticky offset sync: pills + rail pin flush under the real theme header ---- */
  (function () {
    function headerEl() {
      return document.querySelector('header[class*="shopify-section"], .shopify-section-group-header-group header, sticky-header header, header.header-wrapper, body > header');
    }
    var raf = null, lastTop = -1, settle = 0;
    function sync() {
      raf = null;
      var h = headerEl(), top = 0;
      if (h) {
        var hs = getComputedStyle(h);
        if (hs.position === 'sticky' || hs.position === 'fixed') {
          /* live-track the header (it slides away on scroll-down): flush under it
             when visible, flush to the viewport top when hidden */
          top = Math.max(0, Math.round(h.getBoundingClientRect().bottom));
        }
      }
      if (top !== lastTop) {
        lastTop = top;
        document.documentElement.style.setProperty('--bbc-sticky-top', top + 'px');
        settle = 12; /* keep polling while the header animates */
      }
      if (settle > 0) { settle--; raf = requestAnimationFrame(sync); }
    }
    function queue() { settle = 12; if (!raf) raf = requestAnimationFrame(sync); }
    queue();
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    window.addEventListener('load', queue);
  })();

  /* ---- prerender circle destinations (Chrome Speculation Rules, dynamic) ---- */
  (function () {
    try {
      var urls = $$('a.cat[href]').map(function (a) { return a.href; }).filter(function (u, i, arr) { return u && arr.indexOf(u) === i; });
      if (!urls.length) return;
      var sc = document.createElement('script');
      sc.type = 'speculationrules';
      sc.textContent = JSON.stringify({ prerender: [{ urls: urls, eagerness: 'moderate' }] });
      document.body.appendChild(sc);
    } catch (e) {}
  })();

  /* ---- roast badge tap -> toast (card v1.1) ---- */
  document.addEventListener('click', function (e) {
    var rf = e.target.closest && e.target.closest('[data-bbc-roast]');
    if (rf) { e.preventDefault(); bbToast(rf.getAttribute('data-bbc-roast') + ' roast'); }
  });

  /* ---- auto-load next page as the user nears the end (button stays as fallback) ---- */
  window.__bbcInitAutoload = function () {
    var wrap = document.getElementById('bbc-loadWrap');
    if (!wrap || !('IntersectionObserver' in window)) return;
    if (wrap.getAttribute('data-bbc-io')) return;
    wrap.setAttribute('data-bbc-io', '1');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var btn = document.getElementById('bbc-loadMore');
        if (btn && !btn.disabled) btn.click();
        if (!document.getElementById('bbc-loadWrap')) io.disconnect();
      });
    }, { rootMargin: '900px 0px' });
    io.observe(wrap);
  };
  window.__bbcInitAutoload();
  (function () {
    /* scroll-distance fallback (covers environments where IO is throttled) */
    var checking = false;
    window.addEventListener('scroll', function () {
      if (checking) return;
      checking = true;
      setTimeout(function () {
        checking = false;
        var w = document.getElementById('bbc-loadWrap');
        if (!w) return;
        if (w.getBoundingClientRect().top - window.innerHeight < 900) {
          var btn = document.getElementById('bbc-loadMore');
          if (btn && !btn.disabled) btn.click();
        }
      }, 150);
    }, { passive: true });
  })();

  /* ---- discovery flavour chips + smooth anchor scrolling ---- */
  document.addEventListener('click', function (e) {
    var dc = e.target.closest && e.target.closest('[data-bbc-dchip]');
    if (dc) {
      e.preventDefault();
      var grp = dc.closest('.dchips');
      if (grp) Array.prototype.forEach.call(grp.querySelectorAll('.dchip'), function (c) { c.classList.toggle('selected', c === dc); });
      return;
    }
    var an = e.target.closest && e.target.closest('[data-bbc-scroll]');
    if (an) {
      var t = document.getElementById(an.getAttribute('data-bbc-scroll'));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }
  });

  /* ---- view toggle: cards <-> dense list (persisted) ---- */
  (function () {
    var KEY = 'bbc-view';
    function apply(v) {
      var grid = document.getElementById('bbc-grid');
      if (grid) grid.classList.toggle('bbc-grid--list', v === 'list');
      $$('.vt-btn').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-bbc-view') === v)); });
    }
    var saved = 'grid';
    try { saved = localStorage.getItem(KEY) || 'grid'; } catch (e) {}
    apply(saved);
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.vt-btn');
      if (!b) return;
      var v = b.getAttribute('data-bbc-view');
      try { localStorage.setItem(KEY, v); } catch (x) {}
      apply(v);
      ga('bb_view_toggle', { view: v });
    });
    window.__bbcApplyView = function () { var v = 'grid'; try { v = localStorage.getItem(KEY) || 'grid'; } catch (e) {} apply(v); };
  })();
})();
